import * as React from 'react'

function SvgIcici(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="110"
      height="35"
      viewBox="0 0 110 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_209_121534)">
        <path
          d="M19.9919 28.7847H23.6812L26.5982 17.9315H22.909L19.9919 28.7847Z"
          fill="#005B75"
        />
        <path
          d="M39.0396 28.7847H42.7289L45.6459 17.9315H41.9567L39.0396 28.7847Z"
          fill="#005B75"
        />
        <path
          d="M58.0873 28.7847H61.7766L64.6936 17.9315H61.0044L58.0873 28.7847Z"
          fill="#005B75"
        />
        <path
          d="M35.6075 21.6636H39.3396C39.8115 19.2184 38.2671 17.9744 34.6208 17.9744C30.4168 17.9744 27.5427 20.0335 26.5989 23.594C25.741 26.8114 27.4569 28.7847 31.4035 28.7847C35.393 28.7847 37.7524 27.5406 38.7819 24.7523H35.0498C34.535 25.9963 33.5484 26.6398 32.2185 26.6398C30.4168 26.6398 29.7305 25.4815 30.2881 23.4653C30.8458 21.3204 32.2185 20.1193 34.0202 20.1193C35.1356 20.1193 35.6933 20.6341 35.6075 21.6636Z"
          fill="#005B75"
        />
        <path
          d="M54.6552 21.6636H58.3873C58.8592 19.2184 57.3148 17.9744 53.6685 17.9744C49.4645 17.9744 46.5904 20.0335 45.6466 23.594C44.7887 26.8114 46.5046 28.7847 50.4512 28.7847C54.4407 28.7847 56.8001 27.5406 57.8296 24.7523H54.0975C53.5827 25.9963 52.5961 26.6398 51.2662 26.6398C49.4645 26.6398 48.7782 25.4815 49.3358 23.4653C49.8935 21.3204 51.2662 20.1193 53.068 20.1193C54.1833 20.1193 54.741 20.6341 54.6552 21.6636Z"
          fill="#005B75"
        />
        <path
          d="M5.66575 11.9261C10.6419 6.99287 16.6476 5.74884 19.0499 9.09488C21.4522 12.4409 19.3502 19.2188 14.374 24.1091C9.39787 29.0424 3.39216 30.2864 0.989881 26.9404C-1.4124 23.5944 0.689596 16.8165 5.66575 11.9261Z"
          fill="#F99D27"
        />
        <path
          d="M8.96696 9.30914C8.45218 9.69522 7.85161 10.1671 7.33683 10.7248C2.96125 15.0146 1.15954 20.8916 3.30444 23.8515C5.53513 26.8115 10.8545 25.739 15.3158 21.3634C17.6752 19.047 19.3053 16.3444 19.9917 13.8563C20.2062 12.0117 19.9059 10.3816 19.0909 9.13754C17.1176 6.47787 13.0423 6.69237 8.96696 9.30914Z"
          fill="#B02A30"
        />
        <path
          d="M14.9287 9.13804C15.5293 9.69572 15.1432 10.9826 14.1566 11.9693C13.1699 12.9559 11.883 13.2992 11.3253 12.7415C10.7247 12.1838 11.0679 10.8969 12.0975 9.86731C13.0412 8.88066 14.3711 8.58037 14.9287 9.13804ZM11.4111 26.5546C9.09462 28.3134 6.69233 29.1714 4.33295 28.7853C5.3196 28.8282 6.09176 27.7557 6.77813 26.2972C7.4216 24.7958 7.85058 23.423 8.15086 22.0932C8.62274 20.0341 8.66564 18.5756 8.40825 18.2324C8.02217 17.7176 7.12131 17.8463 6.09176 18.4469C5.61989 18.7043 4.93352 18.5327 5.70568 17.5889C6.47784 16.6452 9.56649 14.3716 10.6818 14.0284C11.883 13.6852 13.2986 14.1571 12.8267 15.4869C12.4836 16.4736 8.23666 27.7128 11.4111 26.5546Z"
          fill="white"
        />
        <path
          d="M67.4804 28.7847H73.0571C74.6443 28.7847 75.8026 28.656 76.9608 27.8838C77.733 27.369 78.2907 26.5969 78.5052 25.7389C78.8912 24.2375 78.2049 23.2508 76.5319 22.9935C78.1191 22.6932 79.1486 21.8352 79.4918 20.5912C79.7492 19.6045 79.5347 18.8752 78.8054 18.4034C78.2049 18.0173 77.2611 17.9315 75.9313 17.9315H70.3975L67.4804 28.7847ZM72.285 19.6045H74.6015C76.3174 19.6045 77.1324 19.819 76.8321 20.8915C76.5319 21.9639 75.5881 22.2642 73.8293 22.2642H71.5986L72.285 19.6045ZM70.2688 27.0688L71.1267 23.8943H73.5719C75.4594 23.8943 76.2745 24.2375 75.9313 25.5244C75.631 26.6827 74.6872 27.0688 73.0142 27.0688H70.2688Z"
          fill="#005B75"
        />
        <path
          d="M84.599 28.785H86.8297C86.8726 28.2702 87.0013 27.7126 87.1729 27.112L87.988 24.0663C88.5456 22.0501 87.5161 21.0205 85.028 21.0205C82.5828 21.0205 81.0385 21.8785 80.5237 23.2941H82.6686C82.9689 22.6077 83.5695 22.2645 84.599 22.2645C85.7573 22.2645 86.1433 22.7793 85.8431 23.8947L85.8002 24.0234H84.6419C81.3388 24.0234 79.537 24.6239 79.0223 26.5543C78.6362 28.0129 79.5371 28.9995 81.5533 28.9995C82.8402 28.9995 83.9555 28.5705 84.8564 27.7984L84.599 28.785ZM85.457 25.3103L85.4141 25.439C85.028 26.8546 83.9126 27.6697 82.5399 27.6697C81.5104 27.6697 81.1243 27.2836 81.2959 26.5543C81.5533 25.5677 82.4541 25.3103 84.0413 25.3103H85.457Z"
          fill="#005B75"
        />
        <path
          d="M88.7573 28.7847H90.988L92.0175 24.9239C92.4036 23.5083 93.6905 22.5645 95.0204 22.5645C96.3502 22.5645 96.7792 23.3367 96.3931 24.881L95.3207 28.8276H97.5085L98.7525 24.1946C99.2673 22.2213 98.2806 21.106 96.0928 21.106C94.6772 21.106 93.5189 21.5779 92.5323 22.6074L92.7897 21.2776H90.559C90.3445 22.4787 90.1729 23.208 90.0871 23.5083L88.7573 28.7847Z"
          fill="#005B75"
        />
        <path
          d="M99.5285 28.7847H101.716L102.832 24.7094L105.792 28.7847H108.794L105.491 24.452L109.996 21.2346H107.164L102.96 24.2804L104.676 17.9744H102.488L99.5285 28.7847Z"
          fill="#005B75"
        />
      </g>
      <defs>
        <clipPath id="clip0_209_121534">
          <rect width="110" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgIcici
